import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href"]

import { computed } from 'vue';
import IMenu from '@/js/components/molecules/IMenu.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ListingSort',
  props: {
    params: {},
    sort: {},
    order: {}
  },
  setup(__props: any) {

const props = __props;
const list = [
  {
    sort: 'popular',
    order: 'asc',
    text: '注目順',
  },
  {
    sort: 'listed',
    order: 'desc',
    text: '新着順',
  },
  {
    sort: 'pv',
    order: 'desc',
    text: '閲覧数順',
  },
  {
    sort: 'price',
    order: 'asc',
    text: '価格が安い順',
  },
  {
    sort: 'price',
    order: 'desc',
    text: '価格が高い順',
  },
];
const label = computed(() => list.find((item) => item.sort === props.sort && item.order === props.order)?.text || '');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IMenu, {
    placement: "bottom-end",
    width: "124"
  }, {
    link: _withCtx(() => [
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.$style.label)
      }, [
        _cache[0] || (_cache[0] = _createElementVNode("i", { class: "icon-sort" }, null, -1)),
        _createTextVNode(_toDisplayString(label.value), 1)
      ], 2)
    ]),
    menu: _withCtx(() => [
      _createElementVNode("ul", {
        class: _normalizeClass(_ctx.$style.menu)
      }, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(list, (item) => {
          return _createElementVNode("li", {
            key: item.text,
            class: _normalizeClass([item.sort === _ctx.sort && item.order === _ctx.order && _ctx.$style.active])
          }, [
            _createElementVNode("a", {
              href: `?${_ctx.params}&sort=${item.sort}&order=${item.order}`
            }, _toDisplayString(item.text), 9, _hoisted_1)
          ], 2)
        }), 64))
      ], 2)
    ]),
    _: 1,
    __: [1]
  }))
}
}

})